<template lang="pug">
  include ../mixins
  row(align="center" space="xs")
    cell
      +b.like-button.pointer.BUTTON(@click="toggleActivity" :class="{ 'is-active': isActiveState }")
        img(src="/static/img/like.svg")
    cell
      bem-text(
        tag="p"
        size="xs"
      ) {{_('Понравилось:')}} {{ currentAmount }}
</template>

<script>
import {
  turnBlogLikeResource,
  turnEventLikeResource,
  turnMassMediaBlogLikeResource,
} from '@services/actions.service.js'
import { turnReviewLikeResource } from '@services/review.service.js'
import { djangoToJsBoolean } from '@helpers/utils'

export default {
  name: 'like-action',
  props: {
    isActive: String,
    amount: Number,
    id: String,
    page: String,
  },
  data() {
    return {
      currentAmount: this.amount,
      isActiveState: djangoToJsBoolean(this.isActive),
      resource: {
        article: turnBlogLikeResource,
        event: turnEventLikeResource,
        review: turnReviewLikeResource,
        media: turnMassMediaBlogLikeResource,
      },
    }
  },
  methods: {
    toggleActivity() {
      return this.resource[this.page].execute({}, { id: this.id })
        .then(({ data: { item: { create, count } } }) => {
          this.isActiveState = create
          this.currentAmount = count
        })
    },
  },
}
</script>
